import { render, staticRenderFns } from "./ProductTechnicalFilterChipLabel.vue?vue&type=template&id=ec160796"
import script from "./ProductTechnicalFilterChipLabel.vue?vue&type=script&lang=js"
export * from "./ProductTechnicalFilterChipLabel.vue?vue&type=script&lang=js"
import style0 from "./ProductTechnicalFilterChipLabel.vue?vue&type=style&index=0&id=ec160796&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ColorTemperatureSwatch: require('/app/components/ColorTemperatureSwatch.vue').default})
